import {
  CircularProgress,
  Tooltip,
  Typography,
} from "../../../../../../../../node_modules/@material-ui/core/index"
import React from "react"
import formatNumberWithCommas from "../../../../../../../utils/formatNumberWithCommas"
import LoadingButton from "../../../../../../LoadingButton/index"
import { toggleClickConfirmationDialog } from "../../../../../../../actions/billingDialogs"
import { openSnackBar } from "../../../../../../../actions/snack-bar"
import { getSuperBillingTableData } from "../../../../../../../actions/super"
import { markPaymentReceived } from "../../../../../../../actions/billing"
import formatDate from "../../../../../../../utils/formatDate"
import {
  getShootDetails,
  recallShoot,
} from "../../../../../../../actions/shoots"
import moment from "../../../../../../../../node_modules/moment/moment"

// START - Mark As Paid (on Client)
const markClientAsPaid = (dialogData, dispatch, superTableContext) => {
  let loading = [...superTableContext.buttonLoadingStates.shootsMarkPaidLoading]
  loading = [...loading, dialogData.shoot_id]
  superTableContext.setButtonLoadingStates(oldState => ({
    ...oldState,
    shootsMarkPaidLoading: loading,
  }))
  let callData = {}
  if (dialogData.firstPaidNotDone) {
    callData = {
      paidColumn: "first_paid",
      paymentStatus: 1,
    }
  } else if (dialogData.secondPaidNotDone) {
    callData = {
      paidColumn: "second_paid",
      paymentStatus: 1,
    }
  } else if (dialogData.fullPaidNotDone) {
    callData = {
      paidColumn: "full_paid",
      paymentStatus: 1,
    }
  }
  dispatch(markPaymentReceived(callData, dialogData.client_invoice_id))
    .then(() => {
      dispatch(
        openSnackBar({
          message: "Marked payment as received",
        })
      )
      loading = loading.filter(x => x !== dialogData.shoot_id)
      superTableContext.setButtonLoadingStates(oldState => ({
        ...oldState,
        shootsMarkPaidLoading: loading,
      }))
      dispatch(
        getSuperBillingTableData({
          type: superTableContext && superTableContext.tabValue,
          endDate:
            superTableContext &&
            superTableContext.dateInfo &&
            superTableContext.dateInfo.endDate,
          startDate:
            superTableContext &&
            superTableContext.dateInfo &&
            superTableContext.dateInfo.startDate,
          searchKey:
            superTableContext && superTableContext.debouncedSearchValue,
        })
      )
        .then(res => {
          superTableContext && superTableContext.setTableData(res)
        })
        .catch(err => {
          console.log(err)
          superTableContext.setButtonLoadingStates(oldState => ({
            ...oldState,
            shootsMarkPaidLoading: loading,
          }))
          superTableContext && superTableContext.setTableData([])
        })
    })
    .catch(err => {
      console.log(err)
      superTableContext.setButtonLoadingStates(oldState => ({
        ...oldState,
        shootsMarkPaidLoading: loading,
      }))
      dispatch(
        openSnackBar({
          message: "Unable to change payment received status",
        })
      )
    })
}

const openConfirmPaidShootDialog = (rowData, dispatch, superTableContext) => {
  let dialogData = {
    action: `mark this client as paid via check`,
    confirmationFunc: markClientAsPaid,
    funcArgs: [rowData, dispatch, superTableContext],
  }
  dispatch(toggleClickConfirmationDialog(true, dialogData))
}
// END - Mark as Paid

const shootDetails = dispatch => {
  dispatch(recallShoot(true))
}

const invoiceFrom = {
  gtt: "Go To Team",
  adesk: "Assignment Desk",
  crewmama: "Crew Mama",
  mcs: "Media Content Services",
}

const shootsColumns = (history, dispatch, superTableContext, classes) => {
  return [
    {
      title: "ID",
      field: "shoot_id",
    },
    {
      title: "Company Name",
      field: "crewmama_or_gtt",
      render: rowData => (
        <Typography style={classes.tableTextLight}>
          {invoiceFrom[rowData.crewmama_or_gtt]}
        </Typography>
      ),
    },

    {
      title: "Title",
      field: "shoot_name",
    },
    {
      title: "Client Name",
      field: "client_company",
      render: rowData => (
        <Typography style={classes.tableTextLight}>
          {rowData.client_company}
        </Typography>
      ),
    },

    {
      title: "Shoot End",
      field: "shoot_end_date",
      render: rowData => (
        <Typography style={classes.tableTextLight}>
          {formatDate(rowData.shoot_end_date)}
        </Typography>
      ),
    },

    // {
    //   title: "Date Paid",
    //   field: "",
    //   render: rowData => {
    //     let paidInFullDate = !!rowData.deposit_required
    //       ? rowData.second_paid_date
    //       : rowData.full_paid_date

    //     return (
    //       <Typography style={classes.tableTextLight}>
    //         {paidInFullDate ? formatDate(rowData.paidInFullDate) : "-"}
    //       </Typography>
    //     )
    //   },
    //   sorting: false,
    // },
    {
      title: "Date Paid",
      field: "",
      render: rowData => {
        let checkAfter = moment().isAfter(rowData.paid_date)
        let paidInFullDate = !!rowData.deposit_required
          ? rowData.second_paid_date
          : rowData.full_paid_date

        return (
          <Typography
            style={{
              color: paidInFullDate ? "black" : checkAfter ? "red" : "blue",
            }}
          >
            {paidInFullDate
              ? formatDate(rowData.paidInFullDate)
              : formatDate(rowData.paid_date)}
          </Typography>
        )
      },
      sorting: false,
    },

    // {
    //   title: "Paid in Full",
    //   render: rowData => {
    //     let paid =
    //       (rowData.deposit_required === 1 &&
    //         rowData.first_paid === 1 &&
    //         rowData.second_paid === 1) ||
    //       (rowData.deposit_required !== 1 && rowData.shoot_full_paid === 1)
    //     return (
    //       <Typography style={classes.tableTextLight}>
    //         {!paid ? "No" : "Yes"}
    //       </Typography>
    //     )
    //   },
    //   sorting: false,
    // },
    {
      title: "Total",
      field: "total",
      render: shoot => (
        <Typography>
          $ {formatNumberWithCommas(Number(shoot.total) || 0)}
        </Typography>
      ),
    },
    {
      title: "Expense",
      field: "expense",
      render: shoot => (
        <Typography>
          $ {formatNumberWithCommas(Number(shoot.expense) || 0)}
        </Typography>
      ),
    },
    {
      title: "Discount",
      field: "shoot_discount",
      render: shoot => (
        <Typography>
          $ {formatNumberWithCommas(Number(shoot.shoot_discount) || 0)}
        </Typography>
      ),
    },
    {
      title: "Income",
      field: "income",
      render: shoot => (
        <Typography>
          $ {formatNumberWithCommas(Number(shoot.income) || 0)}
        </Typography>
      ),
    },

    {
      title: "Outstanding Balance",
      render: rowData => {
        let outStandingBalance = Number(rowData.outstandingBalance)

        return (
          <Typography style={classes.tableTextLight}>
            ${" "}
            {/* {firstPaidNotDone || secondPaidNotDone || fullPaidNotDone
              ? formatNumberWithCommas(Number(0))
              : formatNumberWithCommas(Number(rowData.total))} */}
            {formatNumberWithCommas(Number(outStandingBalance))}
          </Typography>
        )
      },
      sorting: false,
    },

    {
      title: "Paid",
      render: rowData => {
        let paidAmount = rowData.clientPay

        return (
          <Typography style={classes.tableTextLight}>
            ${" "}
            {/* {firstPaidNotDone || secondPaidNotDone || fullPaidNotDone
              ? formatNumberWithCommas(Number(0))
              : formatNumberWithCommas(Number(rowData.total))} */}
            {formatNumberWithCommas(Number(paidAmount))}
          </Typography>
        )
      },
      sorting: false,
    },

    {
      title: "Credit",
      render: rowData => {
        let creditAmount = rowData.creditAmount
        return (
          <Typography style={classes.tableTextLight}>
            ${" "}
            {/* {firstPaidNotDone || secondPaidNotDone || fullPaidNotDone
              ? formatNumberWithCommas(Number(0))
              : formatNumberWithCommas(Number(rowData.total))} */}
            {formatNumberWithCommas(Number(creditAmount))}
          </Typography>
        )
      },
      sorting: false,
    },

    // {
    //   title: "Additional Paid",
    //   render: rowData => {
    //     let additionalPaid = rowData.add_amount ? rowData.add_amount : 0

    //     return (
    //       <Typography style={classes.tableTextLight}>
    //         ${" "}
    //         {/* {firstPaidNotDone || secondPaidNotDone || fullPaidNotDone
    //           ? formatNumberWithCommas(Number(0))
    //           : formatNumberWithCommas(Number(rowData.total))} */}
    //         {formatNumberWithCommas(Number(additionalPaid))
    //         }
    //       </Typography>
    //     )
    //   },
    //   sorting: false,
    // },

    // {
    //   title: "Remaning",
    //   render: rowData => {

    //     let remaningBalance = rowData.remaningBalance

    //     return (
    //       <Typography style={classes.tableTextLight}>
    //         $
    //         {formatNumberWithCommas(Number(remaningBalance))}
    //       </Typography>
    //     )
    //   },
    //   sorting: false,
    // },

    // {
    //   title: "",
    //   render: rowData => {
    //     let loadingArray =
    //       superTableContext.buttonLoadingStates.shootsMarkPaidLoading

    //     let firstPaidNotDone =
    //       rowData.deposit_required === 1 &&
    //       rowData.first_payment_type === "check" &&
    //       rowData.first_paid !== 1
    //     let secondPaidNotDone =
    //       rowData.deposit_required === 1 &&
    //       rowData.second_payment_type === "check" &&
    //       rowData.second_paid !== 1
    //     let fullPaidNotDone =
    //       (rowData.deposit_required === 0 ||
    //         rowData.deposit_required === null) &&
    //       rowData.first_payment_type === "check" &&
    //       rowData.shoot_full_paid !== 1
    //     let newRowData = {
    //       firstPaidNotDone: firstPaidNotDone,
    //       secondPaidNotDone: secondPaidNotDone,
    //       fullPaidNotDone: fullPaidNotDone,
    //       ...rowData,
    //     }

    //     if (firstPaidNotDone || secondPaidNotDone || fullPaidNotDone) {
    //       return (
    //         <Tooltip
    //           title={`Mark ${firstPaidNotDone ? "deposit" : "invoice"
    //             } check as paid`}
    //           aria-label="add"
    //         >
    //           <LoadingButton
    //             variant="contained"
    //             color="primary"
    //             className={classes.actionButton}
    //             disabled={loadingArray.includes(rowData.shoot_id)}
    //             style={{ width: "115px" }}
    //             onClick={() =>
    //               openConfirmPaidShootDialog(
    //                 newRowData,
    //                 dispatch,
    //                 superTableContext
    //               )
    //             }
    //           >
    //             {loadingArray.includes(rowData.shoot_id) ? (
    //               <CircularProgress size={22} style={{ color: "inherit" }} />
    //             ) : firstPaidNotDone ? (
    //               "Deposit Paid"
    //             ) : (
    //               "Invoice Paid"
    //             )}
    //           </LoadingButton>
    //         </Tooltip>
    //       )
    //     }
    //     return null
    //   },
    // },
    {
      title: "",
      render: rowData => {
        return (
          <LoadingButton
            variant="contained"
            color="primary"
            className={classes.actionButton}
            onClick={() => {
              shootDetails(dispatch)
              // window.open(`/shoots/${rowData.shoot_id}/billing`, "_blank");
              // window.open(
              //   `https://new-site.crewmama.com/shoots/${rowData.shoot_id}`,
              //   "_blank"
              // )
              window.open(
                `https://crewmama.com/shoots/${
                  rowData.shoot_id
                }/billing/invoice`,
                "_blank"
              )
            }}
          >
            Go to Shoot
          </LoadingButton>
        )
      },
    },
  ]
}

export default shootsColumns
